import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { Loading } from "@/components/common";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import SingolaUscita from "@/pages/SingolaUscita";
import Campagna from "@/pages/Campagna";
import Abbonamenti from "@/pages/Abbonamenti";
import CambioFiori from "@/pages/servizi/CambioFiori";
import Pulizia from "@/pages/servizi/Pulizia";
import Fotografia from "@/pages/servizi/Fotografia";
import AltriServizi from "@/pages/servizi/AltriServizi";
import Extra from "@/pages/Extra";
import Checkout from "@/pages/Checkout";
import Accedi from "@/pages/Accedi";
import ResetPassword from "@/pages/ResetPassword";
import AreaCliente from "@/pages/cliente/AreaCliente";
import NuovaTomba from "@/pages/cliente/NuovaTomba";
import TombaDettaglio from "@/pages/cliente/TombaDettaglio";
import InterventoDettaglio from "@/pages/cliente/InterventoDettaglio";
import AreaPro from "@/pages/pro/AreaPro";
import ProIntervento from "@/pages/pro/ProIntervento";
import Admin from "@/pages/admin/Admin";

const L = (el) => <Layout>{el}</Layout>;

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return L(<Loading />);
  if (!user) return <Navigate to="/accedi" state={{ from: loc.pathname + loc.search }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={L(<Home />)} />
            <Route path="/servizi" element={L(<Servizi />)} />
            <Route path="/servizi/cambio-fiori" element={L(<CambioFiori />)} />
            <Route path="/servizi/pulizia" element={L(<Pulizia />)} />
            <Route path="/servizi/fotografia" element={L(<Fotografia />)} />
            <Route path="/servizi/altri" element={L(<AltriServizi />)} />
            <Route path="/extra" element={L(<Extra />)} />
            <Route path="/singola-uscita" element={L(<SingolaUscita />)} />
            <Route path="/campagna" element={L(<Campagna />)} />
            <Route path="/abbonamenti" element={L(<Abbonamenti />)} />
            <Route path="/accedi" element={L(<Accedi />)} />
            <Route path="/reset-password" element={L(<ResetPassword />)} />
            <Route path="/checkout" element={<Protected roles={["customer"]}>{L(<Checkout />)}</Protected>} />
            <Route path="/area-cliente" element={<Protected roles={["customer"]}>{L(<AreaCliente />)}</Protected>} />
            <Route path="/area-cliente/tombe/nuova" element={<Protected roles={["customer"]}>{L(<NuovaTomba />)}</Protected>} />
            <Route path="/area-cliente/tombe/:id" element={<Protected roles={["customer"]}>{L(<TombaDettaglio />)}</Protected>} />
            <Route path="/area-cliente/interventi/:id" element={<Protected roles={["customer"]}>{L(<InterventoDettaglio />)}</Protected>} />
            <Route path="/area-pro" element={<Protected roles={["professional"]}>{L(<AreaPro />)}</Protected>} />
            <Route path="/area-pro/interventi/:id" element={<Protected roles={["professional"]}>{L(<ProIntervento />)}</Protected>} />
            <Route path="/admin" element={<Protected roles={["admin"]}>{L(<Admin />)}</Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
